import format from "date-fns/format";

export function toFixed(
  value: number | string,
  fractionDigits: number = 2
): string {
  const normalized = +value;
  return normalized.toFixed(fractionDigits);
}

export function formatMoney(
  value: number | string,
  fractionDigits: number = 2
): string {
  const normalized = +value;
  const fixedNunber = normalized.toFixed(fractionDigits);

  return fixedNunber.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatDate(val: string): string {
  const newDate = timeZoneFormat(val);
  return newDate.toLocaleDateString();
}

export function formatDateMDY(date: string) {
  return format(new Date(date), "MMMM dd, yyyy");
}

export function formatDateLocal(date: string) {
  const newDate = new Date(date);
  const timezoneOffset = newDate.getTimezoneOffset();
  const timezoneOffsetMins = timezoneOffset * 60 * 1000;
  const local = newDate.getTime() - timezoneOffsetMins;
  return format(new Date(local), "MM/dd/yy");
}

export function formatDateTime(date: string) {
  const newDate = new Date(date);
  const timezoneOffset = newDate.getTimezoneOffset();
  const timezoneOffsetMins = timezoneOffset * 60 * 1000;
  const local = newDate.getTime() - timezoneOffsetMins;
  return format(new Date(local), "MM/dd/yy h:mm a");
}

export function formatDateForSummary(date: string) {
  const newDate = new Date(date);
  const timezoneOffset = newDate.getTimezoneOffset();
  const timezoneOffsetMins = timezoneOffset * 60 * 1000;
  const local = newDate.getTime() - timezoneOffsetMins;
  return new Date(local);
}

export function timeZoneFormat(val: any) {
  const date = new Date(val);
  const timezoneOffset = date.getTimezoneOffset();
  const timezoneOffsetMins = timezoneOffset * 60 * 1000;
  const utc = date.getTime() + timezoneOffsetMins;
  return new Date(utc);
}

export function formatTimestampWithoutTimeZone(date: string) {
  const newDate = new Date(date.replace(/-/g, "/"));
  return format(newDate, "MM/dd/yy");
}

export function formatTimestampForRateLockSummary(date: string) {
  const newDate = new Date(date);
  return format(newDate, "MM/dd/yy");
}
